export default
{
	icons: [
		{
			name: "blinds",
			x: 1152,
			y: 325
		},
		{
			name: "clock",
			x: 1606,
			y: 91
		},
		{
			name: "whiteboard",
			x: 1724,
			y: 450.05
		},
		{
			name: "drip",
			x: 754.95,
			y: 328.9
		},
		{
			name: "breakfast",
			x: 343,
			y: 534.05
		},
		{
			name: "talk2pat",
			x: 522,
			y: 458.05
		},
		{
			name: "exit",
			x: 978,
			y: 960.05
		},
		{
			name: "zweedseBand",
			x: 661,
			y: 510.05
		},
		{
			name: "glasses",
			x: 282,
			y: 542
		},
		{
			name: "medication",
			x: 592,
			y: 478.5
		},
		{
			name: "water",
			x: 299.5,
			y: 501.5
		},
		{
			name: "shower",
			x: 788,
			y: 550.05
		},
		{
			name: "cad",
			x: 612.95,
			y: 697
		}
	],
	objects: [
		{
			name: "clock",
			x: 1569,
			y: 0
		},
		{
			name: "whiteboard",
			x: 1546,
			y: 547.65
		}
	]
}